import Moralis from 'moralis';
import type { FC, ReactElement } from 'react';
import { useState } from 'react';

import { MoralisContext } from './moralis.context';

interface Props {
  children: ReactElement;
}
export const MoralisContextProvider: FC<Props> = ({ children }) => {
  const [initialized] = useState(false);

  // doesn't work.... (so I have removed the configs)

  return (
    <MoralisContext.Provider value={{ moralis: Moralis, initialized }}>
      {children}
    </MoralisContext.Provider>
  );
};
